export default "__VITE_ASSET__BvYiGmtu__"